exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.appLogin[data-v-06ee2928]{min-width:100vw;min-height:100vh;font-size:24rpx;content:\"viewport-units-buggyfill; min-width: 100vw; min-height: 100vh\"\n}", "", {"version":3,"sources":["/home/ylp/ylp-leadmall-c/src/module/wechat/jump.vue"],"names":[],"mappings":";AACA,2BAA2B,gBAAgB,iBAAiB,gBAAgB,uEAAuE;CAClJ","file":"jump.vue","sourcesContent":["\n.appLogin[data-v-06ee2928]{min-width:100vw;min-height:100vh;font-size:24rpx;content:\"viewport-units-buggyfill; min-width: 100vw; min-height: 100vh\"\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06ee2928","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/module/wechat/jump.vue
// module id = htTn
// module chunks = 1